// Styled Components
import styled from 'styled-components';
import { Flex } from '../components/shared/Flex';
import media from '../style/media';

export const PageContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow-x: hidden;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const ContentWrapper = styled.div`
  width: 100%;
    max-width: 1000px;
    padding: 6rem 1.5rem 2rem;
    margin: 0 auto;
    box-sizing: border-box;
    z-index: 1;
    
    ${media.tablet`
      padding: 8rem 2rem 3rem;
    `}
`;

export const Header = styled.div`
  text-align: left;
`;

export const Logo = styled.img`
  height: 100px;
  margin-bottom: 0.5rem;
`;

export const Title = styled.h1`
  font-size: 2.25rem;
  color: #0f172a;
  margin: 0;
  font-weight: 800;
  letter-spacing: -0.025em;

  ${media.tablet`
    font-size: 2.75rem;
  `}
`;

export const GlassCard = styled.div`
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 32px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.05);
  padding: 2.5rem 1.5rem;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  ${media.tablet`
    padding: 3.5rem 3rem;
  `}
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;

  ${media.mobile`
    grid-template-columns: 1fr 1fr;
  `}

  ${media.tablet`
    gap: 1.5rem;
  `}
`;

export const Field = styled.div`
  background: white;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  padding: 1.25rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.04);
    border-color: #e2e8f0;
  }
`;

export const FieldLabel = styled.div`
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
`;

export const FieldValue = styled.div`
  font-size: 1.125rem;
  color: #0f172a;
  font-weight: 700;
`;

export const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #64748b;
  margin: 0.75rem 0 0;
  line-height: 1.6;
  font-weight: 400;

  ${media.tablet`
    font-size: 1.25rem;
  `}
`;